import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { translate } from 'react-i18next'
import { bindActionCreators } from 'redux'
import ContentHeader from 'component/utils/ContentHeader'
import Button from 'component/Button/index'
import FormModal from 'component/justifications-irc/FormModal'
import CloseWithoutSaveModal from 'component/justifications-irc/CloseWithoutSaveModal'
import SideFilterForm from 'component/justifications-irc/SideFilterForm'
import NewPagination from 'component/pagination/newPagination'
import Row from 'component/utils/Row'
import Col from 'component/utils/Col'
import SuccessModal from 'component/Modal/SuccessModal'
import * as ircActions from 'action/irc'
import FilterIconSVG from 'component/svgComponents/filter'
import SupplyErrorModal from 'component/justifications-irc/supplyErrorModal'
import SizeSelect, {components} from 'react-select'
import DropdownArrow from 'component/svgComponents/dropdownArrow'
import { colourStyles } from 'utils/selectStyle'
import SupplyTable from 'component/justifications-irc/newTable'
import 'component/justifications-irc/newTable.css'
import { ViewModalContainer } from 'component/justifications-irc/ViewModalV2'
import Modal from 'component/Modal/index'
import TextField from 'component/justifications-irc/JustificationTextField'
import 'component/justifications-irc/styles.css'
import { isEmpty } from 'lodash'

class JustificationIRC extends React.Component {

  constructor(props) {
    super(props)
    this.handleSingleEditModal = this.handleSingleEditModal.bind(this)
    this.updateStatus = this.updateStatus.bind(this)
  }

  static propTypes = {
    auth: PropTypes.object.isRequired,
    translate: PropTypes.func.isRequired,
    count: PropTypes.number.isRequired,
    current: PropTypes.number.isRequired,
    fetchIrcJustifications: PropTypes.func.isRequired,
    fetchDeleteIrcJustification: PropTypes.func.isRequired,
    fetchUpdateIrcJustification: PropTypes.func.isRequired,
    saveIrcJustification: PropTypes.func.isRequired,
    saveAllIrcJustification: PropTypes.func.isRequired,
    mock: PropTypes.array.isRequired,
    pages: PropTypes.number.isRequired,
    validateProducts: PropTypes.func.isRequired,
    isUserMatriz: PropTypes.bool.isRequired,
    saveIrcSupplyList: PropTypes.func.isRequired,
    fetchPositions: PropTypes.func.isRequired,
    error: PropTypes.object,
    user: PropTypes.object.isRequired,
  }

  state = {
    sideFilterVisible: false,
    storeMatriz: '999',
    userMatriz: false,
    currentItem: false,
    currentJustification: false,
    newValues: false,
    csvFile: false,
    showProcessingModal: false,
    syncModal: {render:false, details: null},
    showEditModal: false,
    showUploadModal: false,
    errorSaveModal: false,
    successModalMsg: "",
    fileError: false,
    filterValues: {},
    errorModal: { render: false, details: null, detailsErrorMessage:null },
    closeWithoutSaveModal: false,
    closeWithoutSaveEditModal: false,
    maxDays: 5,
    missionsSelectBranchs: [],
    orderByAsc: false,
    page: 0,
    pages: 0,
    limit: 10,
    optionSize: 10,
    openOneEditModal: false,
  }

  componentDidMount(){
    this.handleFetchIrcJustifications()
  }

  componentDidUpdate(prevProps, prevState) {
    if(prevState.optionSize !== this.state.optionSize) {
      this.setState({page: 0}, () => this.handleFetchIrcJustifications())
    }
  }

  handleFetchIrcJustifications = (resetPage = false) => {
    const {filterValues, page, optionSize} = this.state

    const {
      auth: {user},
      fetchIrcJustifications
    }  = this.props

    const hasFilters = Object.keys(filterValues).length !== 0

    if(!hasFilters) {
      const defaultFilters = {
        page,
        size: optionSize,
        type: 2,
        status:2,
      }

      fetchIrcJustifications(user.dsToken, defaultFilters)
    } else {
      const newFilters = {...filterValues}
      newFilters.page = resetPage ? 0 : page
      newFilters.size = optionSize

      fetchIrcJustifications(user.dsToken, newFilters)
    }
  }

  onDelete = async (record) => {
    const { auth: { user }, fetchDeleteIrcJustification } = this.props;

    const deleteParams = {
      idJustification: record.idJustification,
      dsType: record.dsType
    };
  
    try {
      await fetchDeleteIrcJustification(user.dsToken, deleteParams);
  
      this.setState({
        successModalMsg: "A Justificativa foi excluída com sucesso!",
        csvFile: false,
      });

      this.handleFetchIrcJustifications();
    } catch (error) {
      this.setState({
        errorModalMsg: "Ocorreu um erro ao excluir a justificativa. Por favor, tente novamente.",
      });
    }
  }

  onUpdate = async (currentJustification) => {
    const { auth: { user }, fetchUpdateIrcJustification } = this.props;

    const updateParams = {
      idJustification: currentJustification.idJustification,
      dsJustification: currentJustification.dsJustification,
      dsType:currentJustification.dstype,
      type:currentJustification.type
    };

    const onSuccess = () => {
        this.setState({
          successModalMsg: "A justificativa foi atualizada com sucesso!",
          csvFile: false,
          openOneEditModal: false
        });
  
        this.handleFetchIrcJustifications();
    };

    const onError = (error) => {
      const errorMessage =
        error?.response?.data?.message ||
        "Falha ao editar justificativa.";
    
      const detailsErrorMessage =
        error?.response?.data?.dsMessage ||
        "Uma justificativa com a mesma descrição já foi registrada para este tipo.";
  
      this.setState({
        errorSaveModal: true,  
        errorModal: {
          dsMessage: errorMessage,
          detailsErrorMessage,
        },
        openOneEditModal: false,
      });
    };
    
    fetchUpdateIrcJustification(user.dsToken, updateParams, onSuccess, onError);
  }

  onSubmit = async (values) => {
    const { auth: { user }, saveIrcJustification, saveAllIrcJustification } = this.props;

    const saveParams = {
      dsJustification: values.dsListName, 
      dsType: values.type === "1" ? "C050-Loja" : (values.type === "0" ? "C010-Supply" : ""),
      inInactive: values.inInactive !== undefined ? values.inInactive : 0,
      inNotCounted:0,
      justifications: values.justifications
    };

    if (saveParams.dsType === "C050-Loja") {
      saveParams.inInactive = values.inInactive;  
    }

    if (saveParams.dsType === "C010-Supply") {
      saveParams.cdLdap = Number(user.username);
      saveParams.dsLdap = user.fullName; 
    }

    const onSuccess = () => {
      this.setState({
        successModalMsg: "A justificativa foi cadastrada com sucesso!",
        csvFile: false,
      });

      this.handleFetchIrcJustifications();
    };

    const onError = (error) => {
      const errorMessage =
        error?.response?.data?.message ||
        "Falha ao salvar justificativa.";
      
      const detailsErrorMessage =
        error?.response?.data?.dsMessage ||
        "Uma justificativa com a mesma descrição já foi registrada para este tipo.";


      this.setState({
        errorSaveModal: true,
        errorModal: {
          render: true,
          isUpload: false,
          dsMessage: errorMessage,
          detailsErrorMessage
        },
      });
    };

    // Check for multiple justifications
  if (Array.isArray(saveParams.justifications) && saveParams.justifications.length > 0) {
    saveAllIrcJustification(user.dsToken, saveParams, onSuccess, onError);
  } else {
    saveIrcJustification(user.dsToken, saveParams, onSuccess, onError);
  }
   
  }
  
  toggleEdit = (show, irc = {}, closeWithoutSaveModal = false, newValues) => {
    this.setState({ showEditModal: show, currentItem: irc, closeWithoutSaveModal, newValues })
  }

  toggleEditModal = (show, closeWithoutSaveEditModal = false) => {
    this.setState({showEditModal: show, closeWithoutSaveEditModal})
  }

  changeDsJustificationEdit(value) {
    const {currentJustification} = this.state

    const newJustification = {...currentJustification}
    newJustification.dsJustification = value
    this.setState({currentJustification: newJustification})
  }

  handleSingleEditModal(item) {
    this.setState({openOneEditModal: true, currentJustification: item})
  }

  updateStatus(idJustification, active, type) {
    const { auth: { user }, fetchUpdateIrcJustification } = this.props;

    const params = {
      idJustification,
      active,
      type
      
    }

    fetchUpdateIrcJustification(user.dsToken, params)
        .then(() => {
            this.handleFetchIrcJustifications();
        })
        .catch((error) => {
            console.error('Error updating justification:', error);
        });
  }

  renderSingleEditModal() {

    const {currentJustification, openOneEditModal} = this.state
    const {translate} = this.props
    if(!openOneEditModal) return

    return (
      <Modal
        invisible={false}
        className={`justification-modal irc-form-modal`}
        title={"Editar justificativa"}
        cancelButtonText={"Cancelar"}
        confirmButtonText={"Salvar"}
        disabledBgClickClosing
        isConfirmButtonDisabled={!currentJustification.dsJustification}
        isOpen
        noCloseOnConfirm
        onConfirm={() => this.onUpdate(currentJustification)}
        onCloseModal={() => this.setState({openOneEditModal: false, currentJustification: false})}
      >

        <form action='#' onSubmit={(e) => e.preventDefault()} className='w-100'>
          <TextField
            required
            clearIcon
            label={"Justificativa"}
            placeholder={"Digite a justificativa"}
            name={'dsListName'}
            onRightIconClick={() => this.changeDsJustificationEdit("")}
            fill
            onChange={(e) => this.changeDsJustificationEdit(e.target.value)}
            translate={translate}
            value={currentJustification.dsJustification}
            validateValue={(v) => Boolean(v)}
          >
            
          </TextField>
        </form>

      </Modal>
    )
  }

  renderEditModal() {
    const {
      translate,
      auth: { user },
      isUserMatriz,
    } = this.props
    const { currentItem, closeWithoutSaveEditModal, showEditModal, newValues , maxDays, justifications} = this.state

      if(showEditModal) {
        return (
          <FormModal
            hideModal={closeWithoutSaveEditModal}
            maxDays={maxDays || 5}
            translate={translate}
            user={user}
            edit={currentItem}
            onSubmit={this.onSubmit}
            toggleEdit={this.toggleEditModal}
            isUserMatriz={isUserMatriz}
            newValues={newValues}
            onAddJustifications={(justifications)}
          />
        )
      }
  }

  toggleView = (show, irc) => {
    this.setState({ showViewModal: show, currentItem: irc })
  }

  renderViewModal() {
    const {
      translate,
      auth: { user },
    } = this.props
    const { currentItem, showViewModal } = this.state

    if(!showViewModal) return

    return (
        <ViewModalContainer
          translate={translate}
          user={user}
          currentItem={currentItem}
          toggleView={this.toggleView}
          toggleEdit={this.toggleEdit}
          toggleUpload={this.toggleUpload}
        />
      )
    
  }

  renderCloseWithoutSaveEditModal = () => {
    const { translate } = this.props
    const { closeWithoutSaveEditModal, currentItem, csvFile, newValues } = this.state

    if (closeWithoutSaveEditModal) {
      return (
        <CloseWithoutSaveModal
          translate={translate}
          currentItem={currentItem}
          newValues={newValues}
          file={csvFile}
          toggleEditModal={this.toggleEditModal}
        />
      )
    }
  }

  renderCloseWithoutSaveModal = () => {
    const { translate } = this.props
    const { closeWithoutSaveModal, currentItem, csvFile, newValues } = this.state

    if (closeWithoutSaveModal) {
      return (
        <CloseWithoutSaveModal
          translate={translate}
          currentItem={currentItem}
          newValues={newValues}
          file={csvFile}
          toggle={this.toggleUpload}
        />
      )
    }
  }

  onFilter = (values) => {
    const newValues  ={ ...values}
    newValues.orderByAsc = this.state.orderByAsc
    this.setState({ sideFilterVisible: false, filterValues: values }, () => {
      this.setState({page: 0})
      this.handleFetchIrcJustifications(true)
    })
  }

  renderSideFilterForm() {
    const { translate, auth, isUserMatriz } = this.props
    const { sideFilterVisible } = this.state

    return (
      <SideFilterForm
        show={sideFilterVisible}
        closeFilter={() => this.setState({ sideFilterVisible: false })}
        onSubmit={this.onFilter}
        translate={translate}
        auth={auth}
        isUserMatriz={isUserMatriz}
      />
    )
  }

  renderErrorModal = () => {
    const { translate } = this.props
    const {
      errorSaveModal,
      errorModal: { dsMessage, detailsErrorMessage }
    } = this.state

    if(errorSaveModal) {
      return (
        <SupplyErrorModal
          className="irc-supply-error-modal"
          center
          size='sm'
          t={translate}
          handleClose={() => this.setState({
            errorSaveModal: false,
          }, () => this.handleFetchIrcJustifications())}
          msg={dsMessage}
          detailsErrorMessage={detailsErrorMessage}
        />
      )

    }
 
  }

  renderNewPagination = () => {
    const {translate, mock} = this.props
    const {optionSize} = this.state
    const PAGINATION_OPTIONS = [
      { label: '5', value: 5 },
      { label: '10', value: 10 },
      { label: '20', value: 20 },
      { label: '30', value: 30 },
      { label: '40', value: 40 },
    ]

      
    const countItems = () => {

      if(mock.number + 1 === 1) return 1

      return (((mock.number + 1) - 1) * optionSize) + 1
    }

    const DropdownIndicator = props => (
      <components.DropdownIndicator {...props}>
        <DropdownArrow />
      </components.DropdownIndicator>
    )

    if(isEmpty(mock)) return 

    return (
      <Row className="new-relatory-row stock-transfer-pagination" >
        <Col className="align-center margin-bottom ">

          <NewPagination
          navClass='pagination new-relatory'
          count={mock.totalElements}
          current={mock.number + 1}
          getPage={(page) => this.setState({page: page - 1}, () => this.handleFetchIrcJustifications())}
          pages={mock.totalPages}
          />

          <div  className='datasheet-manager-pagination-size-selector show-pages-new-relatory'>
            <Col className="show-per-page-text" xs={7}>{translate('pagination.size.selector')}</Col>
            <Col xs={4}>
              <SizeSelect
                components={{DropdownIndicator}}
                isSearchable={false}
                styles={colourStyles}
                classNamePrefix='react-select'
                onChange={(option) => {
                  this.setState({optionSize: option.value})
                }}
                options={PAGINATION_OPTIONS}
                value={PAGINATION_OPTIONS.find((i) => i.value === optionSize)}
                menuPlacement='top'
              />
            </Col>
          </div>

          <div style={{float: 'left'}} className='datasheet-manager-pagination-size-selector show-items-new-relatory'>
            <Col >{`
            ${translate('pagination.size.show')}
            ${countItems()} - ${(mock.number + 1) * optionSize > mock.totalElements ? mock.totalElements : (mock.number + 1) * optionSize }
            ${translate("pagination.size.of")}
            ${mock.totalElements}
            ${translate("pagination.size.items")}`}
            </Col>
          </div>
        </Col>
      </Row>
    )
  }

  countItems = () => {
    const {page, optionSize} = this.state

    if(page === 1) return 1

    return page === 1 ? 1 : ((page - 1) * optionSize) + 1
  }

  render() {
    const {
      translate,
      mock
    } = this.props
    const { successModalMsg} = this.state

    return (
      <div className='stock-adjustment'>
        <div className='new-style'>
          <ContentHeader>{"Justificativas do IRC"}</ContentHeader>

          <div className='new-style-filter'>
            <section className='container-fluid new-upper-container'>
              
              <div className='col-xs-13'>
                <div style={{marginRight:"5px"}} className='float-right'>
                  <Button
                    className='new-button-style btn-primary'
                    text={"Cadastrar nova justificativa"}
                    onClick={() => this.toggleEdit(true)}
                  />

                  <Button
                    className='new-button-style'
                    text={translate('mobile.filter')}
                    onClick={() => this.setState({ sideFilterVisible: true })}
                    svgIcon
                    svgComponent={<FilterIconSVG newDesign={false} className=" common-download size-filter-default-svg" /> }
                  />
                </div>
              </div>
            </section>
          </div>

        </div>
      
        <div style={{marginTop: "20px"}} className='stock-adjustment-table new'>

          <div style={{boxShadow: (!isEmpty(mock) && mock.content || []).length < 1 && 'none'}} className='outer-table stock-transfer-outer-table'>
            { (!isEmpty(mock) && mock.content || []).length > 0 
            ? 
              <SupplyTable 
              updateStatus={this.updateStatus} 
              handleSingleEditModal={this.handleSingleEditModal} 
              handleDelete={this.onDelete} 
              handleSyncModal={this.handleSyncModal}  
              showViewModal={this.toggleView} 
              justifications={(!isEmpty(mock)) && mock.content || []} 
              translate={translate} 
              handleOrder={this.handleOrderByAsc}  />  
            : 
            <div style={{width: '100%', height: '500px', margin: '0px'}} className='relatory-no-data pictogram-empty'> 
              
              <p>Sem resultado de busca</p>
              
            </div>
            }
            {this.renderNewPagination()}
          </div>

        </div>
        {this.renderSideFilterForm()}
        {this.renderViewModal()}
        {this.renderCloseWithoutSaveModal()}
        {this.renderCloseWithoutSaveEditModal()}
        {this.renderEditModal()}
        {this.renderErrorModal()}
        {this.renderSingleEditModal()}
        {successModalMsg && (
          <SuccessModal
            center
            t={translate}
            msg={successModalMsg}
            size='sm'
            handleClose={() => {
              this.setState({ successModalMsg: false })
              this.handleFetchIrcJustifications()
            }}
            fillButton
            buttonText='OK'
          />
        )}
      </div>
    )
  }
}

const mapStateToProps = ({ auth, ircSupplyReducer, paginateReducer }) => 
   ({
    mock:ircSupplyReducer.list.records ,
    error: ircSupplyReducer.list.error,
    ircSupplyReducer,
    pages: paginateReducer.pages,
    count: paginateReducer.count,
    current: paginateReducer.current,
    isUserMatriz: auth.isUserMatriz,
  })
;
const mapDispatchToProps = (dispatch) =>
  bindActionCreators(ircActions, dispatch)

const JustificationIRCTranslated = translate(null, {
  wait: true,
  translateFuncName: 'translate',
})(JustificationIRC)

export default connect(mapStateToProps, mapDispatchToProps)(JustificationIRCTranslated)

export { JustificationIRC }
